import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * A component for a button the control bar that opens the videos overlay.
 */
export default class OverlayButton extends Button {
  constructor(player, options) {
    super(player, options);

    this.addClass('vjs-menu-button');
    this.addClass('vjs-overlay-button');
    this.addClass('vjs-icon-chapters');
    this.controlText(player.localize('Playlist Videos'));
  }

  handleClick() {
    this.player_.trigger('controls:overlay:open');
  }
}
